import { render, staticRenderFns } from "./PersonalisationContent.vue?vue&type=template&id=b0d82e58"
import script from "./PersonalisationContent.vue?vue&type=script&lang=ts"
export * from "./PersonalisationContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports